<template>
  <div>
    <div class="summary">
      <h3>Ihre Daten</h3>
      <div class="edit">
        <button class="button" @click="changeStep(2)">Bearbeiten</button>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Geschlecht</div>
        <div class="courseDetailDescription">{{ getSalutation(customer.gender) }}</div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Name</div>
        <div class="courseDetailDescription">{{ customer.firstname }} {{ customer.lastname }}</div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Adresse</div>
        <div class="courseDetailDescription">{{ customer.street }} {{ customer.streetNumber }}<br>{{ customer.postal }} {{ customer.city }}</div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">E-Mail</div>
        <div class="courseDetailDescription">{{ customer.email }}</div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Telefon</div>
        <div class="courseDetailDescription">{{ customer.phone }}</div>
      </div>
    </div>
    <div class="summary">
      <h3 class="h3">Daten des Teilnehmers</h3>
      <div class="edit">
        <button class="button" @click="changeStep(3)">Bearbeiten</button>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Geschlecht</div>
        <div class="courseDetailDescription">{{ getSalutation(participant.gender) }}</div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Name</div>
        <div class="courseDetailDescription">{{ participant.firstname }} {{ participant.lastname }}</div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Geburtstag</div>
        <div class="courseDetailDescription">{{ participant.dateOfBirth }}</div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Weitere Informationen</div>
        <div class="courseDetailDescription">{{ participant.moreInformation }}</div>
      </div>
    </div>
    <div class="summary">
      <h3 class="h3">Präferenzen</h3>
      <div class="edit">
        <button class="button" @click="changeStep(1)">Bearbeiten</button>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Schwimmbad</div>
        <div class="courseDetailDescription">{{ preferences.bath.join(', ') }}</div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Kategorie</div>
        <div class="courseDetailDescription">{{ preferences.category.join(', ') }}</div>
      </div>
      <div class="courseDetail">
        <div class="courseDetailTitle">Zeiten</div>
        <div class="courseDetailDescription">
          <ul>
            <li v-for="time in selectedTimeslots" :key="time">{{ time }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WaitingListSummary',
  props: ['customer', 'participant', 'preferences'],
  data () {
    return {
      weekdays: [
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag',
        'Sonntag'
      ]
    }
  },
  computed: {
    selectedTimeslots() {
      let selectedTimeslots = []
      for (let day = 0; day < 7; day++) {
        if (this.preferences.times !== undefined && this.preferences.times[day].start !== '' && this.preferences.times[day].end !== '') {
          selectedTimeslots.push(this.weekdays[day] + ' ' + this.preferences.times[day].start + ' bis ' + this.preferences.times[day].end)
        }
      }
      return selectedTimeslots
    }

  },
  methods: {
    changeStep(value) {
      this.$emit('changeStep', value)
    },
    getSalutation(value) {
      if (value === 'female') return 'Weiblich'
      if (value === 'male') return 'Männlich'
      return 'Divers'
    }
  }
}
</script>

<style scoped>
.summary {
  position: relative;
  margin-bottom: 4rem;

  ul {
    margin: 0;

    li {
      margin: 0;
    }
  }

  .edit {
    position: absolute;
    top: 0;
    right: 0;

    button {
      background-color: transparent;
      border-radius: 0;
      padding: 0;
      margin: 0;
      color: var(--orange);
      letter-spacing: 0;
      text-transform: none;
    }
  }
}
</style>
